export default {
    // 请求发送登录时的手机验证码
    getMobileLoginIdentifyCode: '/api/user/getMobileLoginIdentifyCode',
    // 手机号、验证码登录接口
    mobileLoginH5: '/api/user/mobileLoginV2',
    // 促销满减券列表信息
    fullCouponList: `/api/coupon/v2/getSpuCouponListNoLogin`,
    // 商品详情信息
    productDetail: `/api/product/h5Mall/productDetail`,
    // 预下单接口
    newOrderPreOrder: `/api/order/newPreOrder`,
    // 下单接口
    newPlaceOrder: `/api/order/newPlaceOrder`,
    // 领取满减券
    getProductFullCoupon: `/api/coupon/v2/getCoupon`,
    // 获取预计税率
    getTaxDesc: `/api/product/taxDesc`,
    wxPrePay: "/api/order/prePay", // 获取微信支付请求数据
    // 订单列表
    myOrderList: '/api/order/newListOrder',
    // 更新订单状态
    updateOrderStatus: '/api/order/updateOrderStatus',
    // 获取订单详情
    newDetailOrder: `/api/order/newDetailOrder`,
    // 待支付订单获取支付方式
    getPayType: `/api/order/getPayType`,
    // 查询订单所有物流
    getAllTracesInfo: `/api/order/express/getAllTracesInfo`,
    // 获取订单支付状态
    getOrderPayStatus: `/api/order/getOrderPayStatus`,
    //获取支付完成后提示信息
    getOrderNotes: `/api/order/getOrderNotes`,
    // 用于展示订单支付结果 获取订单详情信息
    orderDetail: `/api/order/detailOrder`,
    getSerTimestamp: `/api/config/getTimestamp`, //获取服务器时间
    //地址
    getUserAddressList: '/api/address/getUserAddressList',
    getSelectArea: '/api/address/selectArea',
    addOrEditUserAddress: '/api/address/addOrEditUserAddress',
    deleteUserAddress: '/api/address/deleteUserAddress',

    getWeixinTicket: "/api/user/weixinTicket", //获取js-sdk config信息
    prePay: "/api/order/prePay",
    selectCoupon: '/api/coupon/v2/selectCoupon',  // 选择优惠券规则

    getUserDetail: "/api/user/getUserDetail",
    //跨境信息填写
    postUpdateMsg: `/api/user/identity/update`,


    // 获取邀请人信息
    getInviteUserInfo: `/api/user/getInviteUserInfo`,

    // 获取cdn列表
    getCDNFormat: `/api/marketing/image/getCDNFormat`,

    // 获取用户协议
    userAgreement: '/api/config/userAgreement',

    // 会员权益页--公告商学院相关
    getNoticeBusSchInfo: '/api/cpsUser/auth/getNoticeBusSchInfo',
    // 会员权益页--会员权益
    getUserRightInfo: '/api/user/auth/getUserRightInfo',
    // 获取用户详细信息
    userInfoDetail: `/api/user/auth/userInfoDetail`,
    // 金币商城信息
    coinEntrance: `/api/access/common/coinEntrance`,
    // 我的订单数量角标
    myOrderCount: `/api/order/myPageCount`,
    // 用户账户资产信息
    userAccountInfo: `/api/user/auth/userAccountInfo`,
    // 我的工具列表
    myTools: `/api/user/getMyPage`,
    // 获取是否展示设置中的红点（vip才调用)
    isShowRedDot: `/api/cpsUser/getIsShowRedDot`,
    // 获取自购返利支付密码状态
    getPayPasswdStatus: `/api/cpsUser/getPayPasswdStatus`,
    // 获取用户手机号
    getUserPhoneNumber: `/api/cpsUser/getUserPhoneNumber`,
    // 设置自购返利支付密码
    setPayPasswd: `/api/cpsUser/setPayPasswd`,
    // 获取手机验证码 设置自购返利支付密码使用
    getPhoneVcode: `/api/cpsUser/getPasswdSetPhoneCode`,
    // 获取素材详情
    getMaterialDetail: `/api/community/material/detail`,
    // 获取素材推荐
    getRecommendMaterial: `/api/community/material/recommend`,
    cartSync: `/api/cart/sync`, // 同步购物车数据
    cartSync2: `/api/cart/v2/sync`, // POP同步购物车
    cartSync3: `/api/cart/v3/sync`, // POP同步购物车
    cartOpt: `/api/cart/opt`, // 购物车商品加减操作
    cartBatchOpt: `/api/cart/batch`, // 购物车商品批量加减操作
    cartSelect: `/api/cart/select`, // 购物车商品选中
    cartDeselect: `/api/cart/deselect`, // 购物车商品反选
    cartDel: `/api/cart/del`, // 购物车商品删除
    shoppingCartcouponList: `/api/cart/coupon/list`, // 购物车获取券列表
    getPlatformCouponList: `/api/coupon/v2/getPlatformCouponList`, // 购物车平台优惠券列表
    shoppingCartGetScaleCoupon: `/api/coupon/getFullScaleCoupon`, // 购物车领取满减活动券
    cartCouponProductList: `/api/marketing/couponProductList`, // 购物车凑单
    cartPromotionProductList: `/api/marketing/promotionProductList`, // 购物车x元y件 m件n折凑单
    cartMultiShopPromotion: `/api/cart/syncMultiShopPromotion`, // 购物车凑单阶梯
    cartMultiShopPromotion3: `/api/cart/v3/syncShopPromotion`, // 购物车凑单阶梯
    selectShopCoupon: `/api/cart/selectShopCoupon`, // 购物车勾选店铺券
    getShopCouponList: `/api/coupon/v2/getShopCouponList`, // 购物车跨店铺券列表
    postRecommendProducts: `/api/marketing/recommend/recommendProducts`, // 猜你喜欢
    getRecommendProducts: `/api/marketing/v2/recommend/recommendProducts`, //首页改版猜你喜欢接口
    // 永久会员，买一赠一
    getPermanentMembersMsg: '/api/cps/activity/givepermanentvip/info', // 赠送资格验证
    surePermanentMembersMsg: '/api/cps/activity/givepermanentvip/userInfo', // 被赠送人信息
    doubleSurePermanentMembersMsg: '/api/cps/activity/givepermanentvip/givevip', // 赠送永久会员
    givepermanentvipBanner: '/api/cps/activity/givepermanentvip/banner', //获取大礼包买一送一背景图
    // 智齿平台接口
    getTenantList: `/tenantpro/open/getTenantList`, // 查询电商平台企业列表
    newUserShelves: '/api/marketing/membership/newUserShelves', // 会员页新人专区/邀新专区

    getVipBanner: '/api/marketing/newUser/v3/category', // 会员页banner

    // 绑定邀请人及手机号
    bindInviteCode: '/api/user/bindInviteCode',
    checkBindPhoneNumForH5: '/api/user/checkBindPhoneNumForH5', // 授权手机号验证
    bindUserPhoneNumForH5V2: `/api/user/v2/bindUserPhoneNumForH5`, //  授权绑定手机号
    getVipCardList: '/api/user/auth/vipCardList', // 获取会员卡列表
    // 会员页年卡会员限量专区
    vipLimitShelves: '/api/marketing/membership/vipLimitShelves',
    // 会员页年卡会员专享专区
    vipShelves: '/api/marketing/membership/v2/vipShelves',
    // 购买||续费会员下单接口
    vipPlaceOrder: '/api/order/recharge/placeOrder',
    // 获取弹窗
    userExt: `/api/user/userExt`,
    // 客服入口进线分流新逻辑
    getSupplyConfig: `/api/supplyConfig/new/group/page`,
    //2.0抖音小程序-领优惠券
    tiktokCoupon: `/api/talent/user/tiktokCoupon`,
    getBannerpicture: `/api/marketing/tiktok/picture`,
    giftBagCategory: `/api/marketing/vip/v2/category`, //大礼包商品列表
    giftBagShare: `/api/marketing/vip/v2/share`, //大礼包分享
    userStatistics: `/api/user/statistics`, //感恩有你
    postCouponExchange: '/api/coupon/exchange',
    getMyCouponList: `/api/coupon/myNewCouponList`,
    getCouponForH5: `/api/coupon/v2/getCouponForH5`, // H5活动页领券
    getPagePreview: `/api/marketing/cms/v2/pagePreview`, // 发布前预览信息
    getPageDetail: `/api/marketing/cms/v2/pageDetail`, // 发布后预览信息
    getPageModule: `/api/marketing/cms/pageModule`, // 获取商品模块信息
}



// WEBPACK FOOTER //
// ./src/api/request_url.js